import { exportSections } from './exportConfig';
import { ExportAktiveMesspunkteToExcel } from './../../features/excelExport/ExportToExcel';
import { AppDispatch, RootState } from './../../app/store';
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { deleteWithAuth, getWithAuth, postJsonWithAuth, postWithAuth, putToS3, putWithAuth } from '../../utils/api';
import { geraeteManagementState } from './geraeteManagementTypes';
import { aktiverMesspunkt, messgeraet, messstelle, routergeraet, betriebsereignis, dokument } from '../../utils/apiTypes';
import { logError } from '../../utils/utils';
import { openSnackbar } from '../../features/snackbar/globalSnackbarSlice';
import { errorHandler } from '../../utils/errorHandling';

export const emptyMessstelle: messstelle = {
    name: "",
    breitengrad: 0,
    hatDaten: false,
    kommentar: "",
    laengengrad: 0,
    schaltfeld: "",
    spannungsebene: "",
    umspannwerk: "",
    stromwandler: "",
    spannungswandler: "",
    zugeordnet: false,
    jemalsZugeordnet: false,
}
export const emptyAktiverMesspunkt: aktiverMesspunkt = {
    name: "",
    schaltfeld: "",
    umspannwerk: "",
    messgeraet: 0,
    router: 0
}
export const emptyGeraet: messgeraet = {
    id: 0,
    seriennummer: "",
    herstellungsjahr: 0,
    firmware: "",
    macadresse: "",
    kommentar: "",
    inbetriebnahmedatum: "",
    wartungsintervall: "",
    zeitsynchronisationsart: "",
    typ: 0,
    ipadresse: "",
    subnetzmaske: "",
    zugeordnet: false,
    jemalsZugeordnet: false
}
export const emptyRouter: routergeraet = {
    id: 0,
    seriennummer: "",
    herstellungsjahr: 0,
    firmware: "",
    macadresse: "",
    kommentar: "",
    inbetriebnahmedatum: "",
    wartungsintervall: "",
    zeitsynchronisationsart: "",
    typ: 0,
    ipadresse: "",
    subnetzmaske: "",
    zugeordnet: false,
    jemalsZugeordnet: false
}
const exportPreSelection: Array<string> = exportSections.flatMap(x => x.exportColumns.map(e => e.column));
// [
//     "name", "breitengrad", "laengengrad", "schaltfeld", "spannungsebene", "wandlerfaktor", "umspannwerk", "kommentar",

//     "messgeraetSeriennummer", "messgeraetIp", "messgeraetSubnetzmaske", "messgeraetHerstellungsjahr", "messgeraetFirmware", "messgeraetMacadresse",
//     "messgeraetInbetriebnahmedatum", "messgeraetWartungsintervall", "messgeraetZeitsynchronisationsart", "messgeraetHersteller", "messgeraetTyp", "messgeraetKommentar",

//     "routerSeriennummer", "routerIp", "routerSubnetzmaske", "routerHerstellungsjahr", "routerFirmware", "routerMacadresse",
//     "routerInbetriebnahmedatum", "routerWartungsintervall", "routerZeitsynchronisationsart", "routerHersteller", "routerTyp", "routerKommentar"
// ];

const initialState: geraeteManagementState = {
    aktiveMesspunkte: [],
    selectedUW: "",
    selectedAktiverMesspunkt: emptyAktiverMesspunkt,
    geraetDaten: emptyGeraet,
    routerDaten: emptyRouter,
    messstelleDaten: emptyMessstelle,
    messstellen: [],
    messgeraete: [],
    routergeraete: [],
    selectedMessstelle: "",
    selectedMessgeraet: "",
    selectedRoutergeraet: "",
    betriebsereignisse: [],
    dokumente: [],
    editMode: false,
    newMode: false,
    messstelleloading: false,
    messgeraetloading: false,
    routergeraetloading: false,
    alteMessstelle: emptyMessstelle,
    alterMessgeraet: emptyGeraet,
    alterRoutergeraet: emptyRouter,
    export: [],
    messpunktLoading: false,
    dokumentLoading: false,
    einzelDokumentLoading: false
    
}

const geraeteManagementSlice = createSlice({
    name: "geraeteManagement",
    initialState,
    reducers: {
        setBetriebsereignisse: (state, action: PayloadAction<betriebsereignis[]>) => {
            state.betriebsereignisse = action.payload;
        },
        setDokumente: (state, action: PayloadAction<dokument[]>) => {
            state.dokumente = action.payload;
        },
        setSelectedUW: (state, action: PayloadAction<string>) => {
            state.selectedUW = action.payload;
        },
        setSelectedAktiverMesspunkt: (state, action: PayloadAction<aktiverMesspunkt>) => {
            state.selectedAktiverMesspunkt = action.payload;
        },
        setAktiveMesspunkte: (state, action: PayloadAction<aktiverMesspunkt[]>) => {
            state.aktiveMesspunkte = action.payload;
        },
        setGeraetDaten: (state, action: PayloadAction<messgeraet>) => {
            state.geraetDaten = action.payload;
        },
        setRouterDaten: (state, action: PayloadAction<routergeraet>) => {
            state.routerDaten = action.payload;
        },
        setMessstelleDaten: (state, action: PayloadAction<messstelle>) => {
            state.messstelleDaten = action.payload;
        },
        setMessstellen: (state, action: PayloadAction<messstelle[]>) => {
            state.messstellen = action.payload;
        },
        setMessgeraete: (state, action: PayloadAction<messgeraet[]>) => {
            state.messgeraete = action.payload;
        },
        setRouter: (state, action: PayloadAction<routergeraet[]>) => {
            state.routergeraete = action.payload;
        },
        setEditMode: (state, action: PayloadAction<boolean>) => {
            state.editMode = action.payload;
            if (action.payload) {
                state.alteMessstelle = state.messstelleDaten ? state.messstelleDaten : emptyMessstelle;
                state.alterMessgeraet = state.geraetDaten ? state.geraetDaten : emptyGeraet;
                state.alterRoutergeraet = state.routerDaten ? state.routerDaten : emptyRouter;
            }
        },
        setNewMode: (state, action: PayloadAction<boolean>) => {
            state.newMode = action.payload;
        },
        discardEdits: (state) => {
            state.editMode = false;
            state.messstelleDaten = state.alteMessstelle;
            state.geraetDaten = state.alterMessgeraet;
            state.routerDaten = state.alterRoutergeraet;
        },
        resetSelection: (state) => {
            state.messstelleDaten = emptyMessstelle;
            state.geraetDaten = emptyGeraet;
            state.geraetDaten = emptyRouter;
        },
        addAktivenMesspunkt: (state, action: PayloadAction<aktiverMesspunkt>) => {
            state.aktiveMesspunkte.push(action.payload);
            state.aktiveMesspunkte.sort((a, b) => a.name < b.name ? -1 : a.name < b.name ? 1 : 0);
        },
        setExportColumn: (state, action: PayloadAction<string>) => {
            if (state.export.includes(action.payload)) {
                state.export.splice(state.export.indexOf(action.payload), 1)
            }
            else {
                state.export.push(action.payload);
            }

        },
        resetExportColumn: (state) => {
            state.export = exportPreSelection;
        },
        setColumnsSelection: (state, column: PayloadAction<string>) => {
            const columnsToSelect = exportSections.filter(section => section.category == column.payload).flatMap(x => x.exportColumns.map(e => e.column));
            for (const currentColumn of columnsToSelect) {
                if (!state.export.includes(currentColumn)) {
                    state.export.push(currentColumn);
                }
            }
        },
        setColumnsDeselection: (state, column: PayloadAction<string>) => {
            const columnsToSelect = exportSections.filter(section => section.category == column.payload).flatMap(x => x.exportColumns.map(e => e.column));
            for (const currentColumn of columnsToSelect) {
                if (state.export.includes(currentColumn)) {
                    state.export.splice(state.export.indexOf(currentColumn), 1);
                }
            }
        },
        removeDokumentFromState: (state, action: PayloadAction<dokument>) => {
            state.dokumente = state.dokumente.filter(x => x.id != action.payload.id);
        },
        setMesspunktLoading: (state, action: PayloadAction<boolean>) => {
            state.messpunktLoading = action.payload;
        },
        setDokumentLoading: (state, action: PayloadAction<boolean>) => {
            state.dokumentLoading = action.payload;
        },
        setEinzelDokumentLoading: (state, action: PayloadAction<boolean>) => {
            state.einzelDokumentLoading = action.payload;
        },
        setMessstelleLoading: (state, action: PayloadAction<boolean>) => {
            state.messstelleloading = action.payload;
        },
        setMessgeraetLoading: (state, action: PayloadAction<boolean>) => {
            state.messgeraetloading = action.payload;
        },
        setRoutergeraetLoading: (state, action: PayloadAction<boolean>) => {
            state.routergeraetloading = action.payload;
        },
    }
});

//Selectors
//_____________________________________________________________
export const selectBetriebsereignisse = (state: RootState): betriebsereignis[] => state.geraeteManagement.betriebsereignisse;
export const selectDokumente = (state: RootState): dokument[] => state.geraeteManagement.dokumente;

export const selectSelectedUW = (state: RootState): string => state.geraeteManagement.selectedUW;
export const selectSelectedAktiverMesspunkt = (state: RootState): aktiverMesspunkt => state.geraeteManagement.selectedAktiverMesspunkt;

export const selectGeraetDaten = (state: RootState): messgeraet => state.geraeteManagement.geraetDaten;
export const selectRouterDaten = (state: RootState): routergeraet => state.geraeteManagement.routerDaten;
export const selectMessstelleDaten = (state: RootState): messstelle => state.geraeteManagement.messstelleDaten;

export const selectMessstellen = (state: RootState): messstelle[] => state.geraeteManagement.messstellen;
export const selectMessgeraete = (state: RootState): messgeraet[] => state.geraeteManagement.messgeraete;
export const selectRouter = (state: RootState): routergeraet[] => state.geraeteManagement.routergeraete;

export const selectAktiveMesspunkte = (state: RootState): aktiverMesspunkt[] => state.geraeteManagement.aktiveMesspunkte;

export const selectMessstelleLoading = (state: RootState): boolean => state.geraeteManagement.messstelleloading;
export const selectMessgeraetLoading = (state: RootState): boolean => state.geraeteManagement.messgeraetloading;
export const selectRoutergeraetLoading = (state: RootState): boolean => state.geraeteManagement.routergeraetloading;

export const selectEditMode = (state: RootState): boolean => state.geraeteManagement.editMode;
export const selectNewMode = (state: RootState): boolean => state.geraeteManagement.newMode;

export const selectExportColumns = (state: RootState): Array<string> => state.geraeteManagement.export;
export const selectMesspunktLoading = (state: RootState): boolean => state.geraeteManagement.messpunktLoading;

export const selectDokumentLoading = (state: RootState): boolean => state.geraeteManagement.dokumentLoading;
export const selectEinzelDokumentLoading = (state: RootState): boolean => state.geraeteManagement.einzelDokumentLoading;

//Actions
//_____________________________________________________________
export const {
    setAktiveMesspunkte,
    setSelectedUW,
    setBetriebsereignisse,
    setDokumente,
    setSelectedAktiverMesspunkt,
    setGeraetDaten,
    setRouterDaten,
    setMessstelleDaten,
    setMessstellen,
    setMessgeraete,
    setRouter,
    resetSelection,
    setEditMode,
    setNewMode,
    discardEdits,
    addAktivenMesspunkt,
    setExportColumn,
    resetExportColumn,
    setColumnsSelection,
    setColumnsDeselection,
    removeDokumentFromState,
    setMesspunktLoading,
    setDokumentLoading,
    setMessstelleLoading,
    setMessgeraetLoading,
    setRoutergeraetLoading,
    setEinzelDokumentLoading,
} = geraeteManagementSlice.actions


export const getMessstellen = () => (
    dispatch: AppDispatch
): void => {
    dispatch(setMessstelleLoading(true));
    getWithAuth("MESSSTELLE", {}).then((response: messstelle[]) => {
        dispatch(setMessstellen(response.filter((e) => !e.zugeordnet)));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMessstelleLoading(false)));
}

export const getMessgeraete = () => (
    dispatch: AppDispatch
): void => {
    dispatch(setMessgeraetLoading(true));
    getWithAuth("MESSGERAET", {}).then((response: messgeraet[]) => {
        dispatch(setMessgeraete(response.filter((e) => !e.zugeordnet)));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMessgeraetLoading(false)));
}

export const getRouter = () => (
    dispatch: AppDispatch
): void => {
    dispatch(setRoutergeraetLoading(true));
    getWithAuth("ROUTER", {}).then((response: routergeraet[]) => {
        dispatch(setRouter(response));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setRoutergeraetLoading(false)));
}

export const createActiveMesspunkt = (messstelle: messstelle, messgeraet: messgeraet, router: routergeraet) => (
    dispatch: AppDispatch
): void => {

    const aktiverMesspunkt: aktiverMesspunkt = { name: messstelle.name, schaltfeld: messstelle.schaltfeld, messgeraet: messgeraet.id, umspannwerk: messstelle.umspannwerk };
    aktiverMesspunkt.router = router != emptyRouter ? router.id : undefined;
    dispatch(addAktivenMesspunkt(aktiverMesspunkt));

    dispatch(setMesspunktLoading(true));
    putWithAuth("AKTIVEMESSPUNKTID", {}, aktiverMesspunkt, aktiverMesspunkt.name).then(() => {
        dispatch(
            openSnackbar({
                message: `Aktiver Messpunkt wurde erfolgreich angelegt.`,
                severity: "success",
                duration: 6000,
            })
        );
        dispatch(resetSelection());
        dispatch(setSelectedUW(aktiverMesspunkt.umspannwerk ? aktiverMesspunkt.umspannwerk : ""));
        dispatch(selectMesspunkt(aktiverMesspunkt));
        dispatch(getMessstellen());
        dispatch(getMessgeraete());
        dispatch(getRouter());
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const getAktiveMesspunkte = () => (
    dispatch: AppDispatch
): void => {
    dispatch(setMesspunktLoading(true));
    getWithAuth("AKTIVEMESSPUNKTE", {}).then((response: aktiverMesspunkt[]) => {
        dispatch(setAktiveMesspunkte(response));
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const selectMesspunkt = (messpunkt: aktiverMesspunkt) => (
    dispatch: AppDispatch
): void => {
    dispatch(setSelectedAktiverMesspunkt(messpunkt));
    if (messpunkt.name != "") {
        dispatch(setMesspunktLoading(true));
        getWithAuth( "MESSSTELLEID", {}, messpunkt.name).then((response: messstelle) => dispatch(setMessstelleDaten(response))).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });
        getWithAuth("MESSGERAETID", {}, messpunkt.messgeraet.toString()).then((response: messgeraet) => dispatch(setGeraetDaten(response))).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });
        if(messpunkt.router != undefined){
            getWithAuth("ROUTERID", {},messpunkt.router?.toString()).then((response: routergeraet) => dispatch(setRouterDaten(response))).catch((error) => {
                logError(error);
                errorHandler(error, dispatch);
            });   
        }
        getWithAuth("BETRIEBSEREIGNISID",{}, messpunkt.name).then((response: betriebsereignis[]) => dispatch(setBetriebsereignisse(response))).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        });
        getWithAuth("DOKUMENTID", {}, messpunkt.name).then((response: dokument[]) => dispatch(setDokumente(response))).catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setMesspunktLoading(false)));
    }
}

export const saveEdit = (aktiverMesspunkt: aktiverMesspunkt, messgeraet: messgeraet, router: routergeraet) => (dispatch: AppDispatch): void => {
    dispatch(setEditMode(false));
    dispatch(setMesspunktLoading(true));

    const aktiverMesspunktTemp = Object.assign({}, aktiverMesspunkt);
    aktiverMesspunktTemp.messgeraet = messgeraet.id;
    aktiverMesspunktTemp.router = router.id != 0 ? router.id : undefined;

    putWithAuth("AKTIVEMESSPUNKTID", {}, aktiverMesspunktTemp, aktiverMesspunktTemp.name)
        .then(() => {
            dispatch(
                openSnackbar({
                    message: `Aktiver Messpunkt wurde erfolgreich geändert.`,
                    severity: "success",
                    duration: 6000,
                })
            );
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const deleteZuordnung = (aktiverMesspunkt: aktiverMesspunkt) => (dispatch: AppDispatch): void => {
    dispatch(setMesspunktLoading(true));
    deleteWithAuth("AKTIVEMESSPUNKTID", {}, aktiverMesspunkt.name)
        .then(() => {
            setSelectedAktiverMesspunkt(emptyAktiverMesspunkt);
            dispatch(
                openSnackbar({
                    message: `Aktiver Messpunkt wurde erfolgreich gelöscht.`,
                    severity: "success",
                    duration: 6000,
                })
            );
            dispatch(getAktiveMesspunkte());
        })
        .catch((error) => {
            logError(error);
            errorHandler(error, dispatch);
        }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const exportAktiveMesspunkte = (exportColumnsSelection: Array<string>) => (dispatch: AppDispatch): void => {
    dispatch(setMesspunktLoading(true));
    const positionArray = exportSections.flatMap(e => e.exportColumns).map(e => e.column);
    const slectionSorted = [...exportColumnsSelection].sort((a, b) => positionArray.findIndex(e => e == a) - positionArray.findIndex(e => e == b));
    postWithAuth("POSTAKTIVEMESSPUNKTE", {}, slectionSorted.join(",")).then((messpunkte) => {
        ExportAktiveMesspunkteToExcel(messpunkte, exportColumnsSelection);
        dispatch(resetExportColumn());
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setMesspunktLoading(false)));
}

export const addDokument = (messstelle: string, datei: File, beschreibung: string): ThunkAction<void, RootState, unknown, AnyAction> => (
    dispatch: AppDispatch
) => {
    const data = new FormData();
    data.append('file', datei);
    dispatch(setEinzelDokumentLoading(true));
    postJsonWithAuth("DOKUMENTE", {}, { id: 0, name: datei.name, messstelle: messstelle, beschreibung: beschreibung, erstelldatum: new Date() })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((response: any) => {
            putToS3(response.url, datei.type, {}, datei)
                .then(() => {
                    dispatch(
                        openSnackbar({
                            message: `${beschreibung} wurde erfolgreich hochgeladen.`,
                            severity: "success",
                            duration: 6000,
                        })
                        
                    );
                    getWithAuth("DOKUMENTID", {}, messstelle).then((dokumente: dokument[]) => dispatch(setDokumente(dokumente))).catch((error) => {
                        logError(error);
                        errorHandler(error, dispatch);
                        
                    }).finally(() => dispatch(setEinzelDokumentLoading(false)));
                }
                )
                .catch((error) => {
                    logError(error);
                    errorHandler(error, dispatch);
                    dispatch(setEinzelDokumentLoading(false))
                })
        }).catch((error) => {
            logError(error);
            dispatch(setEinzelDokumentLoading(false))
        });
};

export const getDokument = (dokument: dokument) => (dispatch: AppDispatch): void => {
    dispatch(setDokumentLoading(true));
    getWithAuth("DATEIID", {}, dokument.id.toString()).then((response) => {
        const link = document.createElement('a');
        //eslint-disable-next-line scanjs-rules/assign_to_href
        link.href = response;
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setDokumentLoading(false)));
}

export const deleteDokument = (dokument: dokument) => (dispatch: AppDispatch): void => {
    dispatch(setDokumentLoading(true));
    deleteWithAuth("DATEIID", {}, dokument.id.toString()).then(() => {
        dispatch(removeDokumentFromState(dokument));
        dispatch(
            openSnackbar({
                message: `${dokument.name} wurde erfolgreich gelöscht.`,
                severity: "success",
                duration: 6000,
            })
        );
    }).catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
    }).finally(() => dispatch(setDokumentLoading(false)));
}

export default geraeteManagementSlice.reducer